/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ChangeEvent, useEffect, useState } from 'react'
import { AiOutlineRight } from 'react-icons/ai'
import { Grid } from '@material-ui/core'

import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import { IListaBoletosDeposito } from 'modules/pagamentos/domain/usecases/ListaBoletosDeposito'
import { IBoletoDepositoResponse } from 'modules/pagamentos/domain/entities/IBoletoDepositoResponse'
import iconDocumento from 'shared/assets/icons/documento.svg'
import {
  TitleArea,
  Text,
  Container,
  Label,
  ContainerText,
  Status,
  IconButtonStyle,
} from './styles'
import DetalhesBoleto from './components/DetalhesBoleto'
import { numberToCurrency } from 'shared/utils/formatters'
import { IBaixarPdfBoletoDeposito } from 'modules/pagamentos/domain/usecases/BaixarPdfBoletoDeposito'

export type TProps = {
  boleto: IBoletoDepositoResponse
  baixarPdfBoletoDeposito: IBaixarPdfBoletoDeposito
}

const Boleto: React.FC<TProps> = ({ boleto, baixarPdfBoletoDeposito }) => {
  const [openDrawerDetalhesBoleto, setOpenDrawerDetalhesBoleto] =
    useState(false)

  return (
    <>
      <Container>
        <Grid container alignItems="center" justifyContent="space-between">
          <ContainerText>
            <Status status={boleto.status} />
            <Text>{boleto.status}</Text>
          </ContainerText>
          {boleto.status === 'Pendente' && (
            <IconButtonStyle
              onClick={() => setOpenDrawerDetalhesBoleto(true)}
              transparent
            >
              <AiOutlineRight />
            </IconButtonStyle>
          )}
        </Grid>
        <ContainerText>
          <Label>Favorecido</Label>
          <Text>{boleto.favorecido}</Text>
        </ContainerText>
        <ContainerText>
          <Label>Vencimento</Label>
          <Text>{boleto.data_de_vencimento}</Text>
          <Label>Valor</Label>
          <Text>{numberToCurrency(boleto.valor)}</Text>
        </ContainerText>
      </Container>
      <DetalhesBoleto
        boleto={boleto}
        open={openDrawerDetalhesBoleto}
        setOpen={setOpenDrawerDetalhesBoleto}
        baixarPdfBoletoDeposito={baixarPdfBoletoDeposito}
      />
    </>
  )
}

export default Boleto
